import { gate } from 'hub-http/gates';
export const GATES = {
  REQUEST_NOTE_RICH_TEXT: gate('ProductApprovals::RequestNoteRichText'),
  USER_SENT_REMINDER_NOTIFICATION: gate('ProductApprovals:UserSentReminderNotification'),
  APPROVAL_DASHBOARD: gate('ProductApprovals::Dashboard'),
  GO_TO_MARKETING_STUDIO: gate('GoToMarketingStudio'),
  CHANGES_REQUESTED: gate('ProductApprovals:ChangesRequested')
};